import React, {
  useState,
  useEffect,
} from "react";


import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../api/config";

import {
  GoogleLogin,
  useGoogleLogin,
} from "@react-oauth/google";

import { jwtDecode } from "jwt-decode";

export default function Login() {

  const navigate = useNavigate();

const params =
  new URLSearchParams(
    window.location.search
  );

const from =
  params.get("redirect") || "/home";

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const [statusText, setStatusText] =
    useState(
      "Trying secure app authentication..."
    );

  // =====================================
  // AUTO APP LOGIN
  // =====================================

useEffect(() => {

  // =====================================
  // HANDLE APP LOGIN SUCCESS
  // =====================================

  const handleAppLogin =
    async () => {

      const params =
        new URLSearchParams(
          window.location.search
        );

      const email =
        params.get("email");

      const isManager =
  params.get("is_manager") === "true";

      // =====================================
      // EMAIL RECEIVED FROM APP LOGIN
      // =====================================

      if (email) {

        try {

          setLoading(true);

          setError("");

          const decodedEmail =
            decodeURIComponent(email);

          console.log(
            "========== APP LOGIN SUCCESS =========="
          );

          console.log(
            "App Login Email:",
            decodedEmail
          );

          // =====================================
          // FETCH USER USING EMAIL
          // =====================================

          const response =
            await fetch(
              `${BASE_URL}/google_login`,
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",
                },

                body: JSON.stringify({
                  email: decodedEmail,
                }),
              }
            );

          const data =
            await response.json();

          console.log(
            "App Login Response:",
            data
          );

          if (data.error) {

            setError(data.error);

            setLoading(false);

            return;
          }

          // =====================================
          // STORE USER
          // =====================================

          const updatedUser = {
  ...data.user,
  is_manager: isManager,
};

localStorage.setItem(
  "user",
  JSON.stringify(updatedUser)
);

          console.log(
            "User Stored Successfully"
          );

          navigate("/home");

          return;

        } catch (err) {

          console.error(
            "App Login Error:",
            err
          );

          setError(
            "App login failed"
          );

          setLoading(false);

          return;
        }
      }

      // =====================================
      // AUTO APP LOGIN
      // =====================================

      console.log(
        "========== AUTO APP LOGIN =========="
      );

      setStatusText(
        "Trying secure app authentication..."
      );

     

     // =====================================
// STRICT APP WEBVIEW DETECTION
// =====================================

// Android WebView usually contains "; wv"
// React Native WebView contains "wv"
// iOS WebView misses "Safari"

const isAndroidWebView =
  /wv/.test(navigator.userAgent) ||
  (
    /Android/.test(navigator.userAgent) &&
    /Version\/[\d.]+/.test(
      navigator.userAgent
    ) &&
    !/Chrome/.test(navigator.userAgent)
  );

const isIOSWebView =
  /iPhone|iPad/i.test(navigator.userAgent) &&
  !/Safari/i.test(navigator.userAgent);

const isActualApp =
  isAndroidWebView || isIOSWebView;

// =====================================
// ONLY TRY APP LOGIN INSIDE REAL APP
// =====================================

if (isActualApp) {

  console.log(
    "Real App WebView Detected"
  );

  window.location.href =
    `${BASE_URL}/app_login`;

} else {

  console.log(
    "Normal Mobile Browser Detected"
  );

  setLoading(false);
}
    };

  handleAppLogin();

}, []);

  // =====================================
  // HANDLE BACKEND ERRORS
  // =====================================

  useEffect(() => {

    const params =
      new URLSearchParams(
        window.location.search
      );

    const error =
      params.get("error");

    if (!error) return;

    setLoading(false);

    switch (error) {

      case "token_missing":

        setError(
          "Authentication token not received from app."
        );

        break;

      case "auth_failed":

        setError(
          "Authentication failed. Please try again."
        );

        break;

      case "user_not_found":

        setError(
          "Employee not found."
        );

        break;

      case "json_parse_error":

        setError(
          "Invalid authentication response."
        );

        break;

      case "app_login_failed":

        setError(
          "App login failed."
        );

        break;

      default:

        setError(
          "Unable to login."
        );
    }

  }, []);

  // =====================================
  // DEFAULT GOOGLE LOGIN
  // =====================================

  const handleGoogleSuccess =
    async (credentialResponse) => {

      try {

        setLoading(true);

        setError("");

        console.log(
          "========== GOOGLE LOGIN START =========="
        );

        const decoded =
          jwtDecode(
            credentialResponse.credential
          );

        console.log(
          "Google User:",
          decoded
        );

        const response =
          await fetch(
            `${BASE_URL}/google_login`,
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({
                email:
                  decoded.email,

                name:
                  decoded.name,
              }),
            }
          );

        const data =
          await response.json();

        console.log(
          "Google Login Response:",
          data
        );

        if (data.error) {

          setError(data.error);

          setLoading(false);

          return;
        }

        const updatedUser = {
  ...data.user,
  is_manager: data.user.is_manager,
};

localStorage.setItem(
  "user",
  JSON.stringify(updatedUser)
);

        navigate(from, { replace: true });

      } catch (err) {

        console.error(err);

        setError(
          "Google login failed"
        );

        setLoading(false);
      }
    };

  // =====================================
  // CUSTOM GOOGLE LOGIN
  // =====================================

  const login = useGoogleLogin({

    onSuccess: async (
      tokenResponse
    ) => {

      try {

        setLoading(true);

        setError("");

        console.log(
          "========== CUSTOM GOOGLE LOGIN START =========="
        );

        const userInfoResponse =
          await fetch(
            "https://www.googleapis.com/oauth2/v3/userinfo",
            {
              headers: {
                Authorization:
                  `Bearer ${tokenResponse.access_token}`,
              },
            }
          );

        const googleUser =
          await userInfoResponse.json();

        console.log(
          "Google User:",
          googleUser
        );

        const response =
          await fetch(
            `${BASE_URL}/google_login`,
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({
                email:
                  googleUser.email,

                name:
                  googleUser.name,
              }),
            }
          );

        const data =
          await response.json();

        console.log(
          "Custom Google Login Response:",
          data
        );

        if (data.error) {

          setError(data.error);

          setLoading(false);

          return;
        }

        const updatedUser = {
  ...data.user,
  is_manager: data.user.is_manager,
};

localStorage.setItem(
  "user",
  JSON.stringify(updatedUser)
);

        navigate(from, { replace: true });

      } catch (err) {

        console.error(err);

        setError(
          "Google login failed"
        );

        setLoading(false);
      }
    },

    onError: () => {

      setError(
        "Google Login Failed"
      );

      setLoading(false);
    },
  });

  // =====================================
  // SHOW GOOGLE LOGIN ONLY AFTER FAILURE
  // =====================================

  useEffect(() => {

    const timer =
      setTimeout(() => {

        setLoading(false);

      }, 1000);

    return () =>
      clearTimeout(timer);

  }, []);

// =====================================
// UI
// =====================================

// FULLSCREEN LOADER
if (loading) {

  return (

    <div style={styles.fullscreenLoader}>

      <div style={styles.loaderCard}>

        <div style={styles.bigLoader}></div>

        <div style={styles.loaderTitle}>
          Leave Portal
        </div>

        <div style={styles.loaderText}>
          {statusText}
        </div>

      </div>

    </div>
  );
}

// MAIN UI
return (

  <div style={styles.container}>

    <div style={styles.card}>

      {/* LOGO */}
      <div style={styles.logo}>
        Leave Portal
      </div>

      {/* TITLE */}
      <h1 style={styles.title}>
        Welcome Back
      </h1>

      <p style={styles.subtitle}>
        Continue with your company account
      </p>

      {/* ERROR */}
      {error && (
        <div style={styles.error}>
          {error}
        </div>
      )}

      {/* GOOGLE LOGIN */}
      <>
        <div style={styles.googleWrapper}>

          <GoogleLogin
            onSuccess={
              handleGoogleSuccess
            }

            onError={() =>
              setError(
                "Google Login Failed"
              )
            }
          />

        </div>

        <button
          style={styles.googleButton}
          onClick={() => login()}
        >
          Continue with Google
        </button>
      </>

    </div>

  </div>
);
}

const styles = {

  container: {

    height: "100vh",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    background:
      "linear-gradient(135deg, #eff6ff, #dbeafe)",

    padding: "20px",
  },

  card: {

    width: "400px",

    maxWidth: "100%",

    background: "#fff",

    padding: "40px 30px",

    borderRadius: "24px",

    boxShadow:
      "0 20px 50px rgba(0,0,0,0.12)",

    textAlign: "center",
  },

  logo: {

    fontSize: "36px",

    fontWeight: "800",

    color: "#0f172a",

    marginBottom: "14px",

    letterSpacing: "0.5px",
  },

  title: {

    marginBottom: "10px",

    fontSize: "30px",

    fontWeight: "700",

    color: "#111827",
  },

  subtitle: {

    color: "#6b7280",

    marginBottom: "24px",

    fontSize: "14px",

    lineHeight: "22px",
  },

  autoLogin: {

    display: "flex",

    flexDirection: "column",

    alignItems: "center",

    justifyContent: "center",

    gap: "14px",

    marginBottom: "20px",

    color: "#2563eb",

    fontSize: "14px",

    fontWeight: "500",

    minHeight: "70px",
  },

  smallLoader: {

    width: "22px",

    height: "22px",

    border:
      "3px solid #dbeafe",

    borderTop:
      "3px solid #2563eb",

    borderRadius: "50%",

    animation:
      "spin 1s linear infinite",
  },

  googleWrapper: {

    display: "flex",

    justifyContent: "center",

    marginTop: "18px",
  },

  googleButton: {

    width: "100%",

    marginTop: "14px",

    padding: "14px",

    borderRadius: "12px",

    border: "none",

    background: "#2563eb",

    color: "#fff",

    fontSize: "15px",

    fontWeight: "600",

    cursor: "pointer",
  },

  error: {

    background: "#fee2e2",

    color: "#b91c1c",

    padding: "12px",

    borderRadius: "12px",

    marginBottom: "20px",

    fontSize: "14px",

    fontWeight: "500",
  },
  fullscreenLoader: {

  position: "fixed",

  inset: 0,

  width: "100%",

  height: "100vh",

  background:
    "linear-gradient(135deg,#eff6ff,#dbeafe)",

  display: "flex",

  justifyContent: "center",

  alignItems: "center",

  zIndex: 99999,

  padding: "20px",

  boxSizing: "border-box",
},

loaderCard: {

  background: "rgba(255,255,255,0.96)",

  padding: "38px 30px",

  borderRadius: "28px",

  width: "100%",

  maxWidth: "360px",

  textAlign: "center",

  boxShadow:
    "0 20px 60px rgba(0,0,0,0.12)",

  border:
    "1px solid rgba(255,255,255,0.7)",
},

bigLoader: {

  width: "58px",

  height: "58px",

  margin: "0 auto 22px",

  border:
    "5px solid #dbeafe",

  borderTop:
    "5px solid #2563eb",

  borderRadius: "50%",

  animation:
    "spin 0.8s linear infinite",
},

loaderTitle: {

  fontSize: "28px",

  fontWeight: "800",

  color: "#0f172a",

  marginBottom: "10px",
},

loaderText: {

  color: "#6b7280",

  fontSize: "14px",

  lineHeight: "22px",

  fontWeight: "500",
},
};
const style = document.createElement("style");

style.innerHTML = `
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`;

document.head.appendChild(style);